import ReactDOM from "react-dom";
import React, { useRef, useEffect, useState } from "react";
import mapboxgl from "mapbox-gl";

import Popup from "./Popup/Popup";
import marker from "../../../assets/icons/dson-marker.png";
import "./mapbox-gl.css";
import classes from "./MapboxMap.module.css";

mapboxgl.accessToken =
  "pk.eyJ1IjoidHJpbWJsZXIiLCJhIjoiY2tlb2FsNDRrMG9zOTJzc2Eyb3pqMjcxMCJ9.Ag0mMOFj0sdUMZuuuNEmKg";

const MapboxMap = () => {
  const mapContainerRef = useRef(null);
  const popUpRef = useRef(new mapboxgl.Popup({ offset: 15 }));

  const [mapSetup] = useState({
    container: mapContainerRef.current,
    style: "mapbox://styles/trimbler/ckex2ol2f1bky18p773z8sd8v",
    center: [-77.198723, 40.203079],
    zoom: 15,
  });

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: mapSetup.style,
      center: mapSetup.center,
      zoom: mapSetup.zoom,
    });

    map.addControl(new mapboxgl.NavigationControl(), "bottom-right");



    map.on("load", () => {
      map.loadImage(marker, (error, image) => {
        if (error) throw error;
        map.addImage("custom-marker", image);

        map.addSource("restaurants", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                properties: {
                  name: "Taqueria Laurita",
                  description: "Authentic Mexican fast food.",
                  address: "150 W. High St.",
                },
                geometry: {
                  coordinates: [-77.193078, 40.201681],
                  type: "Point",
                },
                id: "0221f9776c0b41cf1e2b230d1bbbe87a",
              },
              {
                type: "Feature",
                properties: {
                  name: "Brick Kitchen and Bar",
                  description:
                    "Traditional American cuisine, plus an arsenal of extravagant dishes. Outside seating available.",
                  address: "113 W. High St.",
                },
                geometry: {
                  coordinates: [-77.192023, 40.201975],
                  type: "Point",
                },
                id: "056278d97d58d860885046934392f834",
              },
              {
                type: "Feature",
                properties: {
                  name: "Market Cross Pub",
                  description: "Traditional English pub fare.",
                  address: "113 N. Hanover St.",
                },
                geometry: {
                  coordinates: [-77.1886, 40.203315],
                  type: "Point",
                },
                id: "2f99bbba11c211494d74a209306a1c3b",
              },
              {
                type: "Feature",
                properties: {
                  name: "North Hanover Grille",
                  description:
                    "Restaurant and bar serving casual American cuisine (wraps, sandwiches, pasta, seafood).",
                  address: "37 N. Hanover St.",
                },
                geometry: {
                  coordinates: [-77.188663, 40.202911],
                  type: "Point",
                },
                id: "30d2608d40939004f24e502319142b4e",
              },
              {
                type: "Feature",
                properties: {
                  name: "Hook & Flask Still Works",
                  description:
                    "Firehouse-themed on-site distillery, primarily using Pennsylvania based spirits. Other drinks and pub food offered.",
                  address: "137 N. Hanover St.",
                  note: "Closed on Tuesdays",
                },
                geometry: {
                  coordinates: [-77.188204, 40.2039],
                  type: "Point",
                },
                id: "351e6e2a6973fe32c1d41d43eb82e75a",
              },
              {
                type: "Feature",
                properties: {
                  name: "Fay's Country Kitchen",
                  description:
                    "Breakfast and lunch items including sandwiches, subs, wraps and soups and homemade donuts.",
                  address: "203 S. Hanover St. ",
                },
                geometry: {
                  coordinates: [-77.189476, 40.198265],
                  type: "Point",
                },
                id: "4743db3d5c8bd1fb232480820b4e0045",
              },
              {
                type: "Feature",
                properties: {
                  name: "Leo's Homemade Ice Cream",
                  description:
                    "Traditional and unique ice cream flavors made with fresh ingredients. ATM on premises.",
                  address: "816 W. High St.",
                },
                geometry: {
                  coordinates: [-77.207468, 40.202608],
                  type: "Point",
                },
                id: "49e26170b94bafe27df5188e641c3e75",
              },
              {
                type: "Feature",
                properties: {
                  name: "The Hamilton",
                  description:
                    "Family owned diner specializing in Greek food and their famous hotchee dog.",
                  address: "55 W. High St.",
                },
                geometry: {
                  coordinates: [-77.191328, 40.201758],
                  type: "Point",
                },
                id: "622bfeef46b4e324e86e08ff37f39ff8",
              },
              {
                type: "Feature",
                properties: {
                  name: "Redd's Smokehouse",
                  description: "Homemade Southern-style barbecue.",
                  address: "109 N. Hanover St.",
                  note: "Closed on Tuesdays.",
                },
                geometry: {
                  coordinates: [-77.188613, 40.203226],
                  type: "Point",
                },
                id: "709af6c50af8e592a2a991f392a156f8",
              },
              {
                type: "Feature",
                properties: {
                  name: "Kline Athletic Center",
                  organization: "Dickinson College",
                  address: "575 W High St",
                },
                geometry: {
                  coordinates: [-77.201175, 40.203064],
                  type: "Point",
                },
                id: "7599c39515e52134beb1e8349206af12",
              },
              {
                type: "Feature",
                properties: {
                  name: "Seve-N-Dots",
                  description:
                    "Expertly crafted specialty and traditional pizzas, wraps, subs, sandwiches and salads. Home of the pierogi pizza.",
                  address: "40 E. Louther St.",
                },
                geometry: {
                  coordinates: [-77.187534, 40.202822],
                  type: "Point",
                },
                id: "8a74747e0375ee7b4dd080c7fed39019",
              },
              {
                type: "Feature",
                properties: {
                  name: "Dona Eli's Mexican Cuisine",
                  description: "Authentic homemade Mexican cuisine.",
                  address: "204 N. Hanover",
                },
                geometry: {
                  coordinates: [-77.18879, 40.204863],
                  type: "Point",
                },
                id: "970bc7de88f4f8307decd51eba05f62f",
              },
              {
                type: "Feature",
                properties: {
                  name: "1794 The Whiskey Rebellion",
                  description:
                    "Located on the premises of the Comfort Suites Hotel in downtown Carlisle, enjoy fresh, locally sourced ingredients and the finest craft beers, whiskey and spirits.",
                  address: "10 S. Hanover St.",
                  note: "Opens at 4 p.m.",
                },
                geometry: {
                  coordinates: [-77.18974, 40.20057],
                  type: "Point",
                },
                id: "a6d778fec859a614d0af99065a5f7537",
              },
              {
                type: "Feature",
                properties: {
                  name: "Dickinson College Admission House",
                  address: "20 South College St",
                  organization: "Dickinson College",
                },
                geometry: {
                  coordinates: [-77.196688, 40.200489],
                  type: "Point",
                },
                id: "address.1551718377350244",
              },
              {
                type: "Feature",
                properties: {
                  name: "Holland Union Building (HUB)",
                  address: "28 N. College St.",
                  organization: "Dickinson College",
                },
                geometry: {
                  coordinates: [-77.196619, 40.202935],
                  type: "Point",
                },
                id: "address.2724505758454526",
              },
              {
                type: "Feature",
                properties: {
                  name: "Denim Coffee",
                  description:
                    "Coffee shop featuring full espresso and coffee menu, plus pastries, smoothies and specialty teas. All coffee drinks feature Denim Coffee’s beans, roasted fresh every Tuesday at their nearby roasting facility.",
                  address: "1 S. Hanover St.",
                },
                geometry: {
                  coordinates: [-77.189141, 40.200841],
                  type: "Point",
                },
                id: "address.4115354404533528",
              },
              {
                type: "Feature",
                properties: {
                  name: "Old West",
                  address: "272 W. High St",
                  organization: "Dickinson College",
                },
                geometry: {
                  coordinates: [-77.195150, 40.2030900],
                  type: "Point",
                },
                id: "address.5580633725675182",
              },
              {
                type: "Feature",
                properties: {
                  name: "Café Bruges",
                  description:
                    "Traditional Belgian fare plus an ever-changing selection of Belgian beers.",
                  address: "16 N. Pitt St.",
                },
                geometry: {
                  coordinates: [-77.191568, 40.202311],
                  type: "Point",
                },
                id: "address.5745764980519020",
              },
              {
                type: "Feature",
                properties: {
                  name: "George's Subs & Pizza",
                  description: "Homemade pizza and stromboli.",
                  address: "121 W. High St.",
                },
                geometry: {
                  coordinates: [-77.192914, 40.201889],
                  type: "Point",
                },
                id: "bec725c22796d36950cf52bc4769d7fe",
              },
              {
                type: "Feature",
                properties: {
                  name: "Issei Noodle",
                  description:
                    "Japanese noodle house that combines Japanese, Thai and other Asian influences.",
                  address: "54 W. High St.",
                },
                geometry: {
                  coordinates: [-77.19123, 40.201521],
                  type: "Point",
                },
                id: "d26c7405d01e06766a6dc841ec769f7a",
              },
              {
                type: "Feature",
                properties: {
                  name: "Miseno Pizza & Ristorante",
                  description: "Dine-in and takeout pizza and Italian dishes.",
                  address: "598 W. High St.",
                },
                geometry: {
                  coordinates: [-77.201974, 40.202297],
                  type: "Point",
                },
                id: "d7163aceddad7a695b49e34abb4ca952",
              },
              {
                type: "Feature",
                properties: {
                  name: "Carlisle Diner",
                  description: "Traditional diner fare, 24 hours a day.",
                  address: "800 W. High St.",
                },
                geometry: {
                  coordinates: [-77.206075, 40.202664],
                  type: "Point",
                },
                id: "d95a8277ad7f3d8bdd5df816da7a7a1c",
              },
              {
                type: "Feature",
                properties: {
                  name: "Kimberley's Cafe and Creamery",
                  description: "Breakfast, sandwiches, burgers and ice cream.",
                  address: "530 W. High St.",
                },
                geometry: {
                  coordinates: [-77.200792, 40.202261],
                  type: "Point",
                },
                id: "e0fe12af5b8ed7a7ed83bd2d37c70d87",
              },
              {
                type: "Feature",
                properties: {
                  name: "Spoons Cafe",
                  description:
                    "Specializing in homemade soups, hearty sandwiches and healthy salads made fresh daily.",
                  address: "57 W. Pomfret St.",
                },
                geometry: {
                  coordinates: [-77.19097, 40.20016],
                  type: "Point",
                },
                id: "f9404928c95f23c09235234946f525c2",
              },
              {
                type: "Feature",
                properties: {
                  name: "Grazery",
                  description:
                    "Fresh Mediterranean-inspired salads, sandwiches and soups.",
                  address: "156 W. High St.",
                },
                geometry: {
                  coordinates: [-77.193188, 40.201687],
                  type: "Point",
                },
                id: "fac4fa9386d4d476e515f8839a378529",
              },
              {
                type: "Feature",
                properties: {
                  name: "The Sunrise Café",
                  description:
                    "New York-inspired breakfast and lunch sandwich shop. Homemade cream cheese, pastries, flatbreads and more!",
                  address: "231 N. Hanover Street",
                },
                geometry: {
                  coordinates: [-77.188416, 40.2053],
                  type: "Point",
                },
                id: "fb1cbd37af10df14b24379cb93ccd71a",
              },
              {
                type: "Feature",
                properties: {
                  name: "Gingerbread Man",
                  description: "American pub food, Victorian saloon décor.",
                  address: "5 S. Courthouse Ave.",
                },
                geometry: {
                  coordinates: [-77.189893, 40.200882],
                  type: "Point",
                },
                id: "fbba06769672496b2bb79fd15d665a67",
              },
            ],
          },
        });


        map.addLayer({
          id: "points",
          type: "symbol",
          source: "restaurants",
          layout: {
            "icon-image": "custom-marker",
            // get the title name from the source's "title" property
            "text-field": ["get", "title"],
            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
            "text-offset": [0, 1.25],
            "text-anchor": "top",
          },
        });

        map.on("click", "points", (e) => {
          if (e.features.length) {
            const feature = e.features[0];
            // create popup node
            const popupNode = document.createElement("div");
            ReactDOM.render(<Popup feature={feature} />, popupNode);
            // set popup on map
            popUpRef.current
              .setLngLat(feature.geometry.coordinates)
              .setDOMContent(popupNode)
              .addTo(map);
          }
        });
      });
    

    });

    // const marker = new mapboxgl.Marker()
    // .setLngLat(mapSetup.center)
    // .addTo(map)
  });

  return <div className={classes.MapboxContainer} ref={mapContainerRef} />;
};

export default MapboxMap;
